import { useNavigate } from 'react-router'
import type { ViewsResponse } from '../query/types'
import { tabViews, viewLabel, viewSearch } from './tabViews'

/** The views on a phone (spec-53): the tabs as one native list, with the same links as `ViewTabs`. */
export function ViewSelect({ data, currentKey, params }: { data: ViewsResponse; currentKey: string; params: URLSearchParams }) {
  const navigate = useNavigate()
  return (
    <select
      aria-label="Weergave"
      value={currentKey}
      onChange={(event) => navigate({ search: viewSearch(params, event.target.value).toString() })}
      className="h-11 w-full rounded-lg border border-border bg-background px-3 text-base md:hidden"
    >
      {tabViews(data, currentKey).map((view) => (
        <option key={view.key} value={view.key}>
          {viewLabel(view)}
        </option>
      ))}
    </select>
  )
}
